import { Avatar, TableCell, TableRow, Typography } from '@mui/material';
import useComponentSize from '@rehooks/component-size';
import * as React from 'react';

import { TooltippedTruncatedText } from '~/components/TooltippedTruncatedText';
import { MyPerformanceWidgetTableRow } from '~/scenes/MyWorkspace/components/Widgets/components/MyPerformanceWidget/useMyPerformanceWidget';

import { useSxStyles } from './useStyles';

export interface MyPerformanceProps {
  tableRow: MyPerformanceWidgetTableRow;
  isTabDisabled?: boolean;
}

const handleRowClick = (empId: number) => {
  window.location.href = `/page-ui2-redirect?empId=${empId}&area=performance`;
};

export const MyPerformance: React.FC<MyPerformanceProps> = ({
  tableRow,
  isTabDisabled,
}) => {
  const {
    performance: { employee, scores },
    latestV2Score,
    appraisal,
  } = tableRow;

  const sxStyles = useSxStyles();

  const widgetContentRef = React.useRef<HTMLTableRowElement>(null);
  const { width: widgetContentWidth } = useComponentSize(widgetContentRef);
  const minSizeRender = widgetContentWidth < 320;

  const tableRowProps = isTabDisabled
    ? {
        hover: !isTabDisabled,
      }
    : {
        sx: sxStyles.row,
        onClick: () => handleRowClick(employee.id),
        hover: !isTabDisabled,
      };

  return (
    <TableRow {...tableRowProps} ref={widgetContentRef}>
      <TableCell sx={sxStyles.cell} data-cy="profile-pic">
        <Avatar alt={employee.firstName} src={employee.profilePic} />
      </TableCell>
      {minSizeRender ? (
        <TableCell align="right" sx={sxStyles.cell}>
          <Typography
            component="div"
            sx={sxStyles.nameCell}
            variant="body2"
            data-cy="name"
          >
            {`${employee!.firstName?.charAt(0)}. ${employee!.lastName?.charAt(
              0,
            )}.`}
          </Typography>
        </TableCell>
      ) : (
        <TableCell sx={sxStyles.cell}>
          <Typography component="div" variant="body2">
            <TooltippedTruncatedText dataCy="name">
              {`${employee!.firstName} ${employee!.lastName}`}
            </TooltippedTruncatedText>
          </Typography>
        </TableCell>
      )}
      <TableCell align="right" sx={sxStyles.cell}>
        <TooltippedTruncatedText data-cy="score">
          {scores.total}
        </TooltippedTruncatedText>
      </TableCell>
      <TableCell align="right" sx={sxStyles.cell}>
        <TooltippedTruncatedText data-cy="score2">
          {latestV2Score}
        </TooltippedTruncatedText>
      </TableCell>
      <TableCell align="right" sx={sxStyles.cell}>
        <TooltippedTruncatedText data-cy="appraisal">
          {appraisal.name}
        </TooltippedTruncatedText>
      </TableCell>
      <TableCell align="right" sx={sxStyles.cell}>
        <TooltippedTruncatedText data-cy="appraisal-status">
          {appraisal.status}
        </TooltippedTruncatedText>
      </TableCell>
      <TableCell align="right" sx={sxStyles.cell}>
        <TooltippedTruncatedText data-cy="appraisal-modified">
          {appraisal.lastUpdatedAt}
        </TooltippedTruncatedText>
      </TableCell>
    </TableRow>
  );
};
